import React from "react";
import { STATUS_META, PRODUCT_META } from "../lib/workflows";

export function StatusBadge({ status, testid }) {
  const meta = STATUS_META[status] || STATUS_META["Open Order"];
  return (
    <span data-testid={testid} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${meta.color}`}>
      {status}
    </span>
  );
}

export function ProductBadge({ product, testid }) {
  const meta = PRODUCT_META[product] || PRODUCT_META["Full Search"];
  return (
    <span data-testid={testid} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${meta.color}`}>
      {product}
    </span>
  );
}
